<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="half-title" id="htit"><a id="pg_9">Burn Me Deadly</a></p><a id="pg_9">
</a></section><a id="pg_9">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// halftitle1.vue?892bd83c